module.exports = __webpack_public_path__ + "img/UTQUAI-6.bb7d3c83.jpg";